import { render, staticRenderFns } from "./ItemGridView.vue?vue&type=template&id=7c4cb3bb&scoped=true&"
import script from "./ItemGridView.vue?vue&type=script&lang=js&"
export * from "./ItemGridView.vue?vue&type=script&lang=js&"
import style0 from "./ItemGridView.vue?vue&type=style&index=0&id=7c4cb3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4cb3bb",
  null
  
)

export default component.exports